export default {
    bindings: {
        guest: '=',
        options: '<',
    },
    controller: 'selectExtrasController',
    template: require('../views/select.extras.html')
};



// WEBPACK FOOTER //
// ./frontend/admin/app/modules/basket/components/select.extras.component.js